import React from 'react';
import ourCoreValues from "../../assets/images/our-core-values.png";
import cherish from '../../assets/images/cherish.png'
import ensure from '../../assets/images/ensure.png'
import growth from '../../assets/images/growth.png'
import empower from '../../assets/images/empower.png'
import chevronLeft from "../../assets/images/chevron-left.png"
import chevronRight from "../../assets/images/chevron-right.svg"
import carouselImg1 from "../../assets/images/carousel-img1.png"
import carouselImg2 from "../../assets/images/carousel-img2.png"
import carouselImg3 from "../../assets/images/carousel-img3.png"
import chevronLeftGreen from "../../assets/images/chevron-left-green.png"
import chevronRightGreen from "../../assets/images/chevron-right-green.png"

const OurCoreValues = () => {
  return ( 
    <div>
    <div className="our-core-values">
    <p className="fs-18 font-weight-extrabold">OUR CORE VALUES</p>
    <div className="core-values-carousel">
      <div id="carouselExampleControls1" className="carousel slide" data-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="row">
              <div className="col-md-8">
                <p className="fs-65 text-primary font-weight-thin">We are the<br></br>SmartTribe</p>
                <p>At SmartDrive, we are a tribe. With<br></br> shared values and ideals, SmartTribe<br></br> prizes continuous support and teamwork<br></br> above all else.</p>
              </div>
              <div className="col-md-4">
                <img src={ourCoreValues} alt="Our Core Values" className="slider-img" />
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <div className="row">
              <div className="col-md-8">
                <p className="fs-65 text-primary font-weight-thin">We cherish<br></br>our associates</p>
                <p>At SmartDrive, your happiness and<br></br> growth is our priority. We believe that our<br></br> success is dependent on your success.</p>
              </div>
              <div className="col-md-4">
                <img src={cherish} className="d-block w-100" alt="Cherish" className="slider-img" />
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <div className="row">
              <div className="col-md-8">
                <p className="fs-65 text-primary font-weight-thin">We ensure<br></br> Excellence</p>
                <p>Our collaborative culture builds an<br></br> innovative spirit, leading to a laser-like<br></br> focus on delivering the best possible<br></br> solutions.</p>
              </div>
              <div className="col-md-4">
                <img src={ensure} className="d-block w-100" alt="Ensure" className="slider-img" />
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <div className="row">
              <div className="col-md-8">
                <p className="fs-65 text-primary font-weight-thin">Constant<br></br> Innovation and<br></br> Growth</p>
                <p>SmartDrive’s environment fosters<br></br> innovation, and encourages our<br></br> associates to harness their full potential.</p>
              </div>
              <div className="col-md-4">
                <img src={growth} className="d-block w-100" alt="Growth" className="slider-img" />
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <div className="row">
              <div className="col-md-8">
                <p className="fs-65 text-primary font-weight-thin mt-5 pt-5">Empower</p>
                <p>We empower everyone who embarks on<br></br> this journey to create a better world with<br></br> us. </p>
              </div>
              <div className="col-md-4">
                <img src={empower} className="d-block w-100" alt="Empower" className="slider-img" />
              </div>
            </div>
          </div>
        </div>        
        <a className="carousel-control-prev" href="#carouselExampleControls1" role="button" data-slide="prev">
          <span className="carousel-control-prev" aria-hidden="true"><img src={chevronLeft} alt="Chevron Left" className="mr-5" /></span>
          <span className="sr-only">Previous</span>
        </a>
        <a className="carousel-control-next" href="#carouselExampleControls1" role="button" data-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"><img src={chevronRight} alt="Chevron Right" /></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
    </div>
    </div>
    <div className="culture-carousel">
      <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={carouselImg1} className="d-block w-100" alt="Img 1" />
          </div>
          <div className="carousel-item">
            <img src={carouselImg2} className="d-block w-100" alt="Img 2" />
          </div>
          <div className="carousel-item">
            <img src={carouselImg3} className="d-block w-100" alt="Img 3" />
          </div>
        </div>
        <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
          <span aria-hidden="true"><img src={chevronLeftGreen} alt="Chevron Right" class="chevron-right-green" /></span>
          <span className="sr-only">Previous</span>
        </a>
        <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
          <span aria-hidden="true"><img src={chevronRightGreen} alt="Chevron Left" /></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
    </div>
    </div>
   );
}
 
export default OurCoreValues;